import React, { useContext } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

export const App = () => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route exact path={routes.layoutContainer.path} element={<routes.layoutContainer.component />} />
        <Route exact path={routes.home.path} element={<routes.home.component />} />
        <Route exact path={routes.siteMap.path} element={<routes.siteMap.component />} />
        <Route exact path={routes.siteMapB2C.path} element={<routes.siteMapB2C.component />} />
        <Route exact path={routes.siteMapB2B.path} element={<routes.siteMapB2B.component />} />
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};

App.propTypes = {};

App.defaultProps = {};
